/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsGenerator: {
  name: 'generator';
  data: string;
} = {
  name: 'generator',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3h2V6a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0v-1h-2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4Zm14 12h2v-5h-2v5Zm-2-3v3H3v-3h10Zm0-3v1H3V9h10v1Zm2-1h2V4h-2v5Zm-2-2V4H3v3h10Zm6 2h2v2h-2V9ZM1 21a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
